import {
	UPDATE_NOTIFICATIONS,
	CLEAR_NOTIFICATIONS,
	FILTER_NOTIFICATIONS,
	NEW_NOTIFICATION,
	PAYMENT_REQUIRED,
} from '../actions/types';
import { updateObject } from './utils/globalStateFunctions';

const INITIAL_STATE = {
	lastNotification: {},
	notificationList: [],
	filteredNotifications: [],
	count: 0,
};

const notificationReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case PAYMENT_REQUIRED:
			return updateObject(state, {
				lastNotification: action.payload,
				notificationList: [action.payload, ...state.notificationList],
				count: state.count + 1,
			});
		case NEW_NOTIFICATION:
			console.log('🔔 [notificationReducer] NEW_NOTIFICATION received:', {
				type: action.payload?.type,
				title: action.payload?.title,
				message: action.payload?.message,
				currentCount: state.count,
				newCount: state.count + 1
			});
			return updateObject(state, {
				lastNotification: action.payload,
				notificationList: [action.payload, ...state.notificationList],
				count: state.count + 1,
			});
		case UPDATE_NOTIFICATIONS:
			return updateObject(state, {
				notificationList: action.payload,
				lastNotification: action.payload && action.payload.length > 0 ? action.payload[0] : state.lastNotification,
				count: action.payload.length,
			});
		case CLEAR_NOTIFICATIONS:
			return updateObject(state, {
				count: 0,
			});
		case FILTER_NOTIFICATIONS:
			return updateObject(state, {
				filteredNotifications: action.payload,
			});
		default:
			return state;
	}
};

export default notificationReducer;
